import { aiCreditScoringCapabilitiesData } from 'constants/AiInRecruiting'
import styles from './AiInRecruitingCapabilitiesSection.module.css'

const AiInRecruitingCapabilitiesSection = () => {
  const { title, subtitle, items } = aiCreditScoringCapabilitiesData

  return (
    <section className={styles.capabilitiesSection}>
      <div className="container">
        <div className={`row align-items-start ${styles.header}`}>
          <div className="col-12 col-lg-5">
            <h2 className={styles.sectionTitle}>{title}</h2>
          </div>
          <div className="col-12 col-lg-5 offset-lg-2">
            <p className={styles.sectionSubtitle}>{subtitle}</p>
          </div>
        </div>
        <div>
          {items.map((item, i) => (
            <div
              key={item.id}
              className={`${styles.row} ${i === 0 ? styles.rowActive : ''}`}
            >
              <span className={styles.number}>{item.id}</span>
              <p className={styles.itemTitle}>{item.title}</p>
              <p className={styles.itemDesc}>{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AiInRecruitingCapabilitiesSection
